import { ContractTypeId, OfficeId } from "../../../shared/schema/schema";
import ServiceCodeIssuesOverride from "./ServiceCodeIssuesOverride";

// Props arrive as plain numbers from the AngularJS bridge; cast to branded ids here.
type Props = {
  contractTypeId: number;
  officeId: number;
};

export default function ServiceCodeIssuesOverrideSection({ contractTypeId, officeId }: Props) {
  return (
    <ServiceCodeIssuesOverride
      contractTypeId={contractTypeId as ContractTypeId}
      officeId={officeId as OfficeId}
    />
  );
}
